import React from 'react'

function AboutPage() {
  return (
    <>
      <section className="flat-title ">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-inner style">
                <div className="title-group fs-12">
                  <a className="home fw-6 text-color-3" href="/">
                    Accueil
                  </a>
                  <span>À propos</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="flat-about">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-md-7">
              <div className="heading-about">
                <h2>Des vies meilleures avec de meilleurs logements</h2>
                <h4>
                  Agence immobilière 2.0 offrant des visites
                  autonomes avec entrée autonome pour les
                  acquéreurs, ainsi que des commissions
                  avantageuses pour les vendeurs
                </h4>
                <p className="text-1 text-color-2">
                  Donec bibendum nibh quis nisl luctus, at aliquet ipsum bibendum.
                  Fusce at dui tincidunt nulla semper venenatis at et magna. Mauris
                  turpis lorem, ultricies vel justo sed, ultrices auctor nisi.
                </p>
                <div className="text-box">
                  <p className="font-2 fw-5 font-italic text-color-2">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Suspendisse auctor, mi euismod dignissim scelerisque, eros augue
                    vehicula lectus, quis vestibulum enim augue ut est
                  </p>
                </div>
                <div className="author-box">
                  <h3>Antoine Silver</h3>
                  <p>PDG &amp; Fondateur</p>
                  <img
                    src="/assets/images/img-box/about-signature.png"
                    alt="Signature de Antoine Silver"
                  />
                </div>
              </div>
              <div className="icon-box icon-box2 center">
                <img src="/assets/images/icon/about-2.png" alt="Icône Taux de Vente" />
                <div className="title-icon fw-8 fs-40 font-2 relative">87%</div>
                <h5>Taux de Vente</h5>
              </div>
              <div className="icon-box center">
                <img src="/assets/images/icon/about-1.png" alt="Icône Liste" />
                <div className="title-icon fw-8 fs-26 font-2 relative">975K</div>
                <h5>Clients</h5>
              </div>
            </div>
            <div className="col-lg-5 col-md-5">
              <div className="video-box center">
                <div className="post-video flex-five">
                  <img
                    className="img-2"
                    src="/assets/images/img-box/about-video.jpg"
                    alt="Miniature de la vidéo"
                  />
                  <a
                    href="https://youtu.be/MLpWrANjFbI"
                    className="lightbox-image"
                  >
                    <svg
                      width={11}
                      height={14}
                      viewBox="0 0 11 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 7L3.41715e-07 14L9.53674e-07 -4.80825e-07L11 7Z"
                        fill="#FFA920"
                      />
                    </svg>
                    <i className="ripple" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="flat-service tf-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="heading-section center">
                <h2>Services que nous offrons</h2>
                <p className="text-1 text-color-4">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Integer vel lobortis justo
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="box">
                <div className="icon">
                  <svg
                    width={50}
                    height={50}
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M32.8125 10.9375C34.4701 10.9375 36.0598 11.596 37.2319 12.7681C38.404 13.9402 39.0625 15.5299 39.0625 17.1875M45.3125 17.1875C45.3128 19.0106 44.9142 20.8118 44.1448 22.4646C43.3754 24.1175 42.2537 25.582 40.8585 26.7555C39.4632 27.9291 37.8282 28.7832 36.0679 29.258C34.3077 29.7328 32.4649 29.8168 30.6687 29.5041C29.4958 29.3021 28.2542 29.5583 27.4125 30.4L21.875 35.9375H17.1875V40.625H12.5V45.3125H4.6875V39.4416C4.6875 38.1979 5.18125 37.0041 6.06042 36.1271L19.6 22.5875C20.4417 21.7458 20.6979 20.5041 20.4958 19.3312C20.2004 17.6253 20.2626 15.8766 20.6784 14.196C21.0942 12.5154 21.8546 10.9395 22.9114 9.56815C23.9682 8.19681 25.2983 7.05996 26.8175 6.22963C28.3367 5.39931 30.0118 4.89362 31.7367 4.74462C33.4616 4.59562 35.1986 4.80656 36.8377 5.36406C38.4768 5.92156 39.9822 6.81347 41.2585 7.98327C42.5348 9.15307 43.5542 10.5752 44.252 12.1597C44.9499 13.7441 45.311 15.4562 45.3125 17.1875Z"
                      stroke="#FFA920"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3 className="">Gestion immobilière</h3>
                <p className="text-color-2">
                  condimentum id. Nulla congue nunc vitae odio dictum, euismod
                  mattis eros dapibus
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="box">
                <div className="icon">
                  <svg
                    width={50}
                    height={50}
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.1875 43.75V33.5937C17.1875 32.3 18.2375 31.25 19.5312 31.25H24.2187C25.5125 31.25 26.5625 32.3 26.5625 33.5937V43.75M26.5625 43.75H35.9375V7.38542M26.5625 43.75H42.1875V22.3958M35.9375 7.38542L39.0625 6.25M35.9375 7.38542L14.0625 15.3417M42.1875 22.3958L35.9375 20.3125M42.1875 22.3958L45.3125 23.4375M4.6875 43.75H7.8125M7.8125 43.75H45.3125M7.8125 43.75V6.25H14.0625V15.3417M4.6875 18.75L14.0625 15.3417"
                      stroke="#FFA920"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3 className="">Service de consultation</h3>
                <p className="text-color-2">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque faucibus pretium risus at commodo.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4">
              <div className="box">
                <div className="icon">
                  <svg
                    width={50}
                    height={50}
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M25.001 37.4999V26.5624M25.001 26.5624C26.0551 26.5633 27.1051 26.431 28.126 26.1687M25.001 26.5624C23.947 26.5633 22.897 26.431 21.876 26.1687M29.6885 41.7479C26.5912 42.336 23.4109 42.336 20.3135 41.7479M28.126 46.7124C26.0484 46.93 23.9537 46.93 21.876 46.7124M29.6885 37.4999V37.0999C29.6885 35.052 31.0594 33.302 32.8302 32.2749C35.8052 30.5521 38.129 27.8962 39.4415 24.7188C40.754 21.5413 40.9819 18.0197 40.0899 14.6996C39.198 11.3795 37.236 8.44622 34.5078 6.35428C31.7797 4.26235 28.4379 3.12854 25 3.12854C21.5622 3.12854 18.2203 4.26235 15.4922 6.35428C12.7641 8.44622 10.802 11.3795 9.91006 14.6996C9.01811 18.0197 9.24604 21.5413 10.5585 24.7188C11.871 27.8962 14.1948 30.5521 17.1698 32.2749C18.9406 33.302 20.3135 35.052 20.3135 37.0999V37.4999"
                      stroke="#FFA920"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3 className="">Vente de biens immobiliers</h3>
                <p className="text-color-2">
                  Nulla facilisi. Praesent vulputate mollis ante feugiat mattis.
                  Vestibulum felis nunc, faucibus ac varius eget, tempor
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

     
      
     
    </>
  );
}

export default AboutPage